module.exports = __webpack_public_path__ + "img/register.d12c6057.svg";